import { useTranslation } from "react-i18next";
import { FormSelect } from "../../Inputs/FormInputs";
import { VEHICLE_CONDITIONS } from "../../../Constants/CheckInOut";
import { useState } from "react";
import instance from "../../../Interceptor/api_instance";
import { ActionResponse } from "../../Modals/ActionResponses";
import { Spinner } from "../../LoadingAnimations/LoadingAnimations";

const EditTruckCondition = ({ close, row }) => {
  const truck = row.truck;
  const [condition, setCondition] = useState(truck.truck_condition);
  const [loading, setLoading] = useState(false);
  const [responseModal, setResponseModal] = useState(null);
  const { t } = useTranslation();

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await instance.patch(
        `/assets/edit-condition/truck/${truck.id}/${condition}`
      );
      if (response.status === 200) {
        setResponseModal({
          status: t("forms.type.success"),
          message: t("forms.responses.success"),
        });
      }
    } catch (err) {
      setResponseModal({
        status: t("forms.type.error"),
        message: err,
      });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {responseModal ? (
        <ActionResponse
          status={responseModal.status}
          message={responseModal.message}
          close={
            responseModal.status === t("forms.type.success")
              ? () => window.location.reload()
              : () => setResponseModal(null)
          }
        />
      ) : (
        <div className="page-mask page-mask-animation">
          <div className="white-cont">
            <div className="flex-1">
              <label className="input-label">
                {t("yard-tables.tabs.truck")}:
              </label>
              <div className="input-cont">
                <label>{row.truck.unit}</label>
              </div>
            </div>
            {/* Form group: Condition */}
            <FormSelect
              label={"truckCondition"}
              options={VEHICLE_CONDITIONS}
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
            />
            {loading ? (
              <Spinner />
            ) : (
              <div className="full-cont">
                <button
                  className="change-pwd-btn"
                  type="button"
                  onClick={handleSubmit}
                >
                  {t("buttons.submit")}
                </button>
                <button className="cancel-btn" type="button" onClick={close}>
                  {t("buttons.cancel")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default EditTruckCondition;
